import axios from "axios";
import ERRORS from "./Http/errors";

/**
 * variable
 */
const token =
  JSON.parse(localStorage.getItem(`@adplistdashboard_${process.env.NODE_ENV}`))
    ?.currentUser?.token?.actual || null;

export const apiBaseUrl = `${process.env.REACT_APP_BASE_API}`; //process.env.NODE_ENV === "production" ? "https://api.adplist.org/" : "https://api.adpstaging.cloud/";
export const siteUrl = `${process.env.REACT_APP_SITE_URL}`; //"https://adplist.org/";
export const mentorUrl = (slug) => siteUrl + "mentors/" + slug;
export const designerUrl = (slug) => siteUrl + "members/" + slug;
export const groupSessionUrl = (slug) => siteUrl + "session/" + slug;

export const http = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// create axios config object
export const createConfig = (authToken = token, file = false) => {
  if (!authToken) return null;

  let headers = { Authorization: `Token ${authToken}` };
  if (file)
    headers = {
      ...headers,
      "Content-Type": "multipart/form-data",
      Accept: "application/*",
    };
  return {
    headers: headers,
  };
};

// create api response
export const createResponse = (success, data, message) => ({
  success,
  message,
  data,
});

//SWR fetcher
export const SWRFetcher =
  (currentUser) =>
  (
    path,
    config = {
      headers: { Authorization: `Token ${currentUser.token.actual}` },
    }
  ) =>
    http.get(path, config).then((resp) => resp.data);

// fetch data
export const fetchData = (url, authToken = token) =>
  axios
    .get(`${apiBaseUrl}${url}`, createConfig(authToken))
    .then((response) => createResponse(true, response.data, null))
    .catch((error) => handleError(error));

// post data
export const postData = (url, data, file = false, authToken = token) =>
  axios
    .post(`${apiBaseUrl}${url}`, data, createConfig(authToken, file))
    .then((response) => createResponse(true, response.data, null))
    .catch((error) => handleError(error, authToken ? false : true));

// update data
export const putData = (url, data, file = false, authToken = token) =>
  axios
    .put(`${apiBaseUrl}${url}`, data, createConfig(authToken, file))
    .then((response) => createResponse(true, response.data, null))
    .catch((error) => handleError(error));

// delete data
export const deleteData = (url, file = false, authToken = token) =>
  axios
    .delete(`${apiBaseUrl}${url}`, createConfig(authToken, (file = false)))
    .then((response) => createResponse(true, response.data, null))
    .catch((error) => handleError(error));

// handler error

//fetch file
export const fetchFile = async (url, authToken, config_) => {
  // set config

  const config = {
    baseURL: apiBaseUrl,
    headers: { Authorization: `Token ${authToken}` },
    responseType: "blob",
    ...config_,
  };

  try {
    let response = await axios.get(`${url}`, config);
    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return handleError(error);
  }
};

export const handleError = (error, isLogin = false) => {
  if (error.response) {
    console.log("error.response", error.response);
    switch (error.response.status) {
      case 401:
        const message = isLogin
          ? error.response.data.message
          : ERRORS.LOGIN_EXPIRED;
        return createResponse(false, null, message);
      case 404:
        return createResponse(false, null, ERRORS.NOT_FOUND);
      case 403:
        return {
          success: false,
          message:
            "You do not have access to this resource. Contact your system administrator to grant you access.",
        };
      case 400:
      case 409:
        return createResponse(
          false,
          error.response,
          error.response.data.message || error.response.data?.error
        );
      default:
        return createResponse(false, null, ERRORS.UNKNOWN_SERVER_ERROR);
    }
  }

  return createResponse(false, null, ERRORS.UNKNOWN_ERROR);
};

const Http = (url, request = axios.get, file = false, authToken = token) => {
  // default axios config

  return request(`${apiBaseUrl}${url}`, createConfig(authToken, (file = false)))
    .then((response) => createResponse(true, response.data, null))
    .catch((error) => handleError(error));
};

export default Http;
